import type { FC, SVGProps } from 'react';

const InfoIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 1.25C18.1904 1.25 18.75 1.80964 18.75 2.5V17.5C18.75 18.1904 18.1904 18.75 17.5 18.75H2.5C1.80964 18.75 1.25 18.1904 1.25 17.5V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H17.5ZM2.5 0C1.11929 0 0 1.11929 0 2.5V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5V2.5C20 1.11929 18.8807 0 17.5 0H2.5Z"
      fill="currentColor"
    />
    <path
      d="M11.1634 8.23486L8.29961 8.59375L8.19707 9.06982L8.76103 9.17236C9.12725 9.26025 9.20049 9.39209 9.11992 9.7583L8.19707 14.0942C7.95537 15.2148 8.32891 15.7422 9.20781 15.7422C9.88896 15.7422 10.68 15.4272 11.0389 14.9951L11.1487 14.4751C10.8997 14.6948 10.5335 14.7827 10.2918 14.7827C9.94756 14.7827 9.82305 14.541 9.91094 14.1162L11.1634 8.23486Z"
      fill="currentColor"
    />
    <path
      d="M11.25 5.625C11.25 6.31536 10.6904 6.875 10 6.875C9.30964 6.875 8.75 6.31536 8.75 5.625C8.75 4.93464 9.30964 4.375 10 4.375C10.6904 4.375 11.25 4.93464 11.25 5.625Z"
      fill="currentColor"
    />
  </svg>
);

export default InfoIcon;
